import { Extension } from "@tiptap/core";

// Allow only a single line of text
export const SingleLine = Extension.create({
	addKeyboardShortcuts() {
		return {
			"Enter": () => true
		}
	},
});